module.exports = __webpack_public_path__ + "img/invitingStudentsSubgroup.5e50d033.jpg";